import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './components/ProtectedRoute';

// --- IMPORTS ESTRUCTURALES ---
import Header from './components/Header';
import Footer from './components/Footer';
import { CartProvider } from './components/CartContext'; 
import { Toaster } from 'react-hot-toast'; // Opcional: si usas react-hot-toast global

// --- IMPORTS PEREZOSOS (Lazy Loading) ---
const AdminDashboard = lazy(() => import('./components/dashboard/AdminDashboard'));
const ClientDashboard = lazy(() => import('./components/dashboard/ClientDashboard'));

const Login = lazy(() => import('./components/Login'));
const Register = lazy(() => import('./components/Register'));
const Home = lazy(() => import('./components/Home'));
const Catalogo = lazy(() => import('./components/Catalogo')); 
const Carrito = lazy(() => import('./components/Carrito')); 
const CreaTuRamo = lazy(() => import('./components/CreaTuRamo'));

// --- COMPONENTES LEGALES ---
const PrivacyPolicy = lazy(() => import('./components/PrivacyPolicy'));
const TermsOfService = lazy(() => import('./components/TermsOfService'));

// --- MARKETING DINÁMICO ---
const DynamicPage = lazy(() => import('./components/DynamicPage'));

// Pantalla de Carga Elegante
const LoadingScreen = () => (
  <div className="h-screen w-full flex flex-col items-center justify-center bg-gray-50 gap-6">
    <div className="relative">
      <div className="w-16 h-16 border-4 border-orange-100 border-t-orange-500 rounded-full animate-spin"></div>
      <div className="absolute inset-0 flex items-center justify-center">
        <div className="w-2 h-2 bg-orange-500 rounded-full"></div>
      </div>
    </div>
    <p className="text-orange-500 font-bold text-sm tracking-widest animate-pulse uppercase">Cargando...</p>
  </div>
);

function App() {
  return (
    <CartProvider>
      <BrowserRouter>
        {/* Contenedor Principal: min-h-screen asegura altura completa, flex-col organiza verticalmente */}
        <div className="flex flex-col min-h-screen bg-[#F8FAFC]">
          
          <Header />
          <Toaster position="top-right" /> {/* Notificaciones Globales */}

          {/* Main: flex-grow empuja el footer hacia abajo */}
          <main className="flex-grow pt-24 w-full relative">
            <Suspense fallback={<LoadingScreen />}>
              <Routes>
                
                {/* --- RUTAS PÚBLICAS --- */}
                <Route path="/" element={<Home />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/catalogo" element={<Catalogo />} />
                <Route path="/carrito" element={<Carrito />} />
                <Route path="/cotizar/crea-tu-ramo" element={<CreaTuRamo />} />

                {/* --- RUTA DINÁMICA (CMS) --- */}
                <Route path="/pages/:slug" element={<DynamicPage />} />

                {/* --- LEGAL --- */}
                <Route path="/privacidad" element={<PrivacyPolicy />} />
                <Route path="/terminos" element={<TermsOfService />} />

                {/* --- ÁREA CLIENTE --- */}
                <Route element={<ProtectedRoute requireDashboard={false} />}>
                    <Route path="/mi-cuenta" element={<ClientDashboard />} />
                </Route>

                {/* --- ÁREA ADMIN (Ruta Wildcard para sub-rutas internas) --- */}
                <Route element={<ProtectedRoute requireDashboard={true} />}>
                  <Route path="/admin-panel/*" element={<AdminDashboard />} />
                </Route>

                {/* Redirección legacy si alguien entra a /admin */}
                <Route path="/admin" element={<Navigate to="/admin-panel" replace />} />

                {/* --- ERROR 404 --- */}
                <Route path="*" element={
                  <div className="flex flex-col items-center justify-center h-[60vh] text-center px-4">
                    <h1 className="text-9xl font-black text-gray-200">404</h1>
                    <div className="bg-orange-50 p-4 rounded-full mb-4 -mt-16 relative z-10">
                        <span className="text-4xl">🥀</span>
                    </div>
                    <h2 className="text-2xl font-bold text-gray-800 mb-2">Página no encontrada</h2>
                    <p className="text-gray-500 mb-8 max-w-md">Lo sentimos, la página que buscas no existe o ha sido movida.</p>
                    <a href="/" className="px-8 py-3 bg-orange-500 text-white rounded-xl font-bold shadow-lg hover:bg-orange-600 hover:shadow-orange-200 transition-all transform hover:-translate-y-1">
                      Volver al Inicio
                    </a>
                  </div>
                } />

              </Routes>
            </Suspense>
          </main>

          <Footer />

        </div>
      </BrowserRouter>
    </CartProvider>
  );
}

export default App;